// extracted by mini-css-extract-plugin
module.exports = {"social-tags-wrapper":"OaFbv","tag-items":"_2wY2J","name":"xavTj"};